import { IGlobalStore } from "../store/global/GlobalStore";

export const enum OrderType {
  OneToOne = "121",
  OneToMany = "12M",
  ManyToOne = "M21",
}
export const getOrderType = (state: IGlobalStore): OrderType | undefined => {
  const numMakerTokens = state.makerTokens.length;
  const numTakerTokens = state.takerTokens.length;
  if (numTakerTokens === 1 && numMakerTokens === 1) {
    return OrderType.OneToOne;
  } else if (numTakerTokens > 1 && numMakerTokens === 1) {
    return OrderType.ManyToOne;
  } else if (numMakerTokens > 1 && numTakerTokens === 1) {
    return OrderType.OneToMany;
  }
  return undefined;
};

export const getOrderTypeName = (orderType: OrderType) => {
  if (orderType === OrderType.OneToOne) {
    return "One to one";
  } else if (orderType === OrderType.ManyToOne) {
    return "Many to one";
  } else {
    // else catches not just 12M orderType but also 12MPercentages which comes back from the backend on some older trades
    return "One to many";
  }
};
